import { jsxs as s, jsx as r } from "react/jsx-runtime";
import * as n from "@radix-ui/react-toast";
import { X as x, Info as y, AlertTriangle as w, XCircle as k, CheckCircle2 as T } from "lucide-react";
import { forwardRef as C } from "react";
function R(o) {
  switch (o) {
    case "success":
      return {
        bg: "var(--success-bg)",
        border: "var(--success-border)",
        fg: "var(--success)"
      };
    case "error":
      return {
        bg: "var(--error-bg)",
        border: "var(--error-border)",
        fg: "var(--error)"
      };
    case "warning":
      return {
        bg: "var(--warning-bg)",
        border: "var(--warning-border)",
        fg: "var(--warning)"
      };
    case "info":
      return {
        bg: "var(--info-bg)",
        border: "var(--info-border)",
        fg: "var(--info)"
      };
    case "loading":
      return {
        bg: "var(--accent-dim)",
        border: "var(--accent-border)",
        fg: "var(--accent-default)"
      };
    case "neutral":
    default:
      return {
        bg: "var(--bg-elevated)",
        border: "var(--border-strong)",
        fg: "var(--text-primary)"
      };
  }
}
function W(o) {
  const e = {
    width: "var(--icon-md)",
    height: "var(--icon-md)",
    flex: "0 0 auto"
  };
  switch (o) {
    case "success":
      return /* @__PURE__ */ r(T, { "aria-hidden": !0, style: e });
    case "error":
      return /* @__PURE__ */ r(k, { "aria-hidden": !0, style: e });
    case "warning":
      return /* @__PURE__ */ r(w, { "aria-hidden": !0, style: e });
    case "info":
      return /* @__PURE__ */ r(y, { "aria-hidden": !0, style: e });
    case "loading":
      return /* @__PURE__ */ s(
        "svg",
        {
          "aria-hidden": !0,
          viewBox: "0 0 16 16",
          style: {
            ...e,
            animation: "ls-spin var(--duration-spinner) var(--ease-linear) infinite"
          },
          children: [
            /* @__PURE__ */ r(
              "circle",
              {
                cx: "8",
                cy: "8",
                r: "6",
                fill: "none",
                stroke: "currentColor",
                strokeOpacity: "0.2",
                strokeWidth: "2"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                d: "M14 8a6 6 0 0 0-6-6",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
              }
            )
          ]
        }
      );
    case "neutral":
    default:
      return null;
  }
}
const I = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--space-3)",
  padding: "var(--space-3) var(--space-4)",
  background: "var(--bg-elevated)",
  border: "1px solid var(--border-strong)",
  borderRadius: "var(--radius-xl)",
  boxShadow: "var(--shadow-lg)",
  color: "var(--text-primary)",
  fontFamily: "var(--font-sans)",
  fontSize: "var(--text-sm)",
  lineHeight: "var(--line-sm)",
  minWidth: "280px",
  maxWidth: "420px",
  pointerEvents: "auto",
  animation: "ls-fade-up var(--duration-slow) var(--ease-out)"
}, j = C(function({
  title: e,
  description: l,
  tone: t = "neutral",
  action: a,
  icon: d,
  dismissible: u = !0,
  dismissAriaLabel: v = "Dismiss",
  pauseOnHover: S = !0,
  duration: g,
  onPause: f,
  onResume: p,
  ...b
}, h) {
  const i = R(t), m = t === "error" || t === "warning" ? "foreground" : "background", c = d !== void 0 ? d : W(t);
  return /* @__PURE__ */ s(
    n.Root,
    {
      ref: h,
      type: m,
      duration: g,
      onPause: f,
      onResume: p,
      "data-tone": t,
      style: {
        ...I,
        background: i.bg,
        borderColor: i.border
      },
      ...b,
      children: [
        c ? /* @__PURE__ */ r(
          "span",
          {
            "aria-hidden": !0,
            style: {
              color: i.fg,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "2px"
            },
            children: c
          }
        ) : null,
        /* @__PURE__ */ s(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-1)",
              flex: "1 1 auto",
              minWidth: 0
            },
            children: [
              /* @__PURE__ */ r(
                n.Title,
                {
                  style: {
                    fontWeight: "var(--font-weight-semibold)",
                    color: "var(--text-primary)",
                    fontSize: "var(--text-sm)",
                    lineHeight: "var(--line-sm)"
                  },
                  children: e
                }
              ),
              l ? /* @__PURE__ */ r(
                n.Description,
                {
                  style: {
                    color: "var(--text-secondary)",
                    fontSize: "var(--text-sm)",
                    lineHeight: "var(--line-sm)"
                  },
                  children: l
                }
              ) : null
            ]
          }
        ),
        a ? /* @__PURE__ */ r(
          n.Action,
          {
            asChild: !0,
            altText: a.altText ?? (typeof a.label == "string" ? a.label : "Action"),
            children: /* @__PURE__ */ r(
              "button",
              {
                type: "button",
                onClick: a.onClick,
                className: "ls-focus-ring",
                style: {
                  background: "transparent",
                  color: i.fg,
                  border: "1px solid transparent",
                  padding: "var(--space-1) var(--space-2)",
                  borderRadius: "var(--radius-md)",
                  fontFamily: "inherit",
                  fontSize: "var(--text-sm)",
                  fontWeight: "var(--font-weight-semibold)",
                  cursor: "pointer",
                  flex: "0 0 auto"
                },
                children: a.label
              }
            )
          }
        ) : null,
        u ? /* @__PURE__ */ r(
          n.Close,
          {
            "aria-label": v,
            className: "ls-focus-ring",
            style: {
              background: "transparent",
              border: "none",
              color: "var(--text-secondary)",
              padding: "var(--space-1)",
              borderRadius: "var(--radius-sm)",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              flex: "0 0 auto"
            },
            children: /* @__PURE__ */ r(x, { "aria-hidden": !0, style: { width: "var(--icon-sm)", height: "var(--icon-sm)" } })
          }
        ) : null
      ]
    }
  );
});
export {
  j as T
};
//# sourceMappingURL=Toast-DgN3m1Qm.js.map
